import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {updatePath} from "../store/slices/utilSlice";

const PathTracker = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updatePath(location.pathname));
    }, [location.pathname]);

    return null;
};

export default PathTracker;